import { render, staticRenderFns } from "./DictTransformType.vue?vue&type=template&id=2548feca&scoped=true&"
import script from "./DictTransformType.vue?vue&type=script&lang=js&"
export * from "./DictTransformType.vue?vue&type=script&lang=js&"
import style0 from "./DictTransformType.vue?vue&type=style&index=0&id=2548feca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548feca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2548feca')) {
      api.createRecord('2548feca', component.options)
    } else {
      api.reload('2548feca', component.options)
    }
    module.hot.accept("./DictTransformType.vue?vue&type=template&id=2548feca&scoped=true&", function () {
      api.rerender('2548feca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictTransformType.vue"
export default component.exports